export const etagToVersion = etag => etag == null ? etag : etag.replaceAll(/[W/"]/g, '')
const versionToIfMatch = version => version == null ? version : `"${version}"`

export const withIfMatch = (version, config) =>
  version == null ? config : { ...config, headers: { ...config?.headers, 'If-Match': versionToIfMatch(version) } }
